import { createClient } from '@supabase/supabase-js'
import requests from '../../components/Requests/requests';

const supabaseUrl = requests.supabaseUrl
const supabaseAnonKey = requests.supabaseAnonKey

export const supabase = createClient(supabaseUrl, supabaseAnonKey)